import { useCallback } from 'react';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useGetRGConfiguration = () => {
    const send = useGenericSend();

    return useCallback(async (
        { type, casino, currencyCode }: Types.IGetRGConfigurationRequest
    ) => {
        const { data } = await send<Types.IGetRGConfigurationRequest, Types.IGetRGConfigurationResponse>({
            ID: 32942,
            responses: [32943, 32944],
            description: 'Get Responsible Gaming Configuration',
            type,
            ...casino && { casino },
            ...currencyCode && { currencyCode }
        });

        return data;
    }, [send]);
};
